var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"footer_contacts"},[_c('region-delivery-label'),_vm._v(" "),_c('a',{staticClass:"footer_contacts_phone",attrs:{"href":'tel:' + _vm.$region.getPhone()}},[_vm._v(_vm._s(_vm.$region.getPhone()))])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }